<template>

  <div class="pt-2 component">
    <r-row class="mb-8">
      <r-col
        :cols="{ widest: 8, wide: 8, middle: 6, narrow: 6 }">
        <span class="parmigiano troy--text">
          Колонка растягивается, адаптируясь под размер экрана, отступы бывают трёх размеров
        </span>
      </r-col>
    </r-row>
    <r-row class="mb-8">
      <r-col
        :cols="{ widest: 12, wide: 12, middle: 6, narrow: 6 }">
        <r-tabs
          :items="itemsTabs"
          v-model="tabActive"
        />
      </r-col>
    </r-row>
    <template v-if="tabActive.id === 'description'">
      <r-row class="mb-10">
        <r-col
          :cols="{ widest: 6, wide: 6, middle: 3, narrow: 6 }">
          <svg width="100%" height="120" viewBox="0 0 391 120" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">
            <path d="M292.192 18.36H295.532V8.06L292.192 10.44V8.4L295.572 6H297.452V18.36H300.192V20H292.192V18.36ZM307.099 20.2C306.325 20.2 305.625 20.0733 304.999 19.82C304.372 19.5667 303.832 19.18 303.379 18.66C302.939 18.1267 302.599 17.46 302.359 16.66C302.119 15.86 301.999 14.9067 301.999 13.8V13.4C301.999 12.0267 302.139 10.86 302.419 9.9C302.699 8.92667 303.079 8.14 303.559 7.54C304.039 6.92667 304.599 6.48667 305.239 6.22C305.879 5.94 306.565 5.8 307.299 5.8C308.379 5.8 309.285 6.06 310.019 6.58C310.765 7.08667 311.259 7.86 311.499 8.9H309.619C309.245 7.95333 308.472 7.48 307.299 7.48C306.792 7.48 306.325 7.56667 305.899 7.74C305.472 7.91333 305.099 8.2 304.779 8.6C304.472 9 304.225 9.53333 304.039 10.2C303.852 10.8667 303.745 11.7 303.719 12.7C303.905 12.38 304.132 12.1067 304.399 11.88C304.665 11.64 304.952 11.4533 305.259 11.32C305.579 11.1733 305.905 11.0667 306.239 11C306.572 10.9333 306.892 10.9 307.199 10.9C308.599 10.9 309.712 11.2933 310.539 12.08C311.379 12.8533 311.799 13.9667 311.799 15.42V15.62C311.799 16.2867 311.672 16.9 311.419 17.46C311.179 18.02 310.845 18.5067 310.419 18.92C309.992 19.32 309.492 19.6333 308.919 19.86C308.345 20.0867 307.739 20.2 307.099 20.2ZM306.939 18.52C307.912 18.52 308.652 18.2733 309.159 17.78C309.665 17.2867 309.919 16.5733 309.919 15.64V15.44C309.919 14.52 309.665 13.8133 309.159 13.32C308.652 12.8267 307.912 12.58 306.939 12.58C305.965 12.58 305.225 12.8267 304.719 13.32C304.212 13.8133 303.959 14.52 303.959 15.44V15.64C303.959 16.56 304.212 17.2733 304.719 17.78C305.225 18.2733 305.965 18.52 306.939 18.52Z" fill="var(--rir-alien)"/>
            <path d="M370.192 18.36H373.532V8.06L370.192 10.44V8.4L373.572 6H375.452V18.36H378.192V20H370.192V18.36ZM385.099 20.2C384.325 20.2 383.625 20.0733 382.999 19.82C382.372 19.5667 381.832 19.18 381.379 18.66C380.939 18.1267 380.599 17.46 380.359 16.66C380.119 15.86 379.999 14.9067 379.999 13.8V13.4C379.999 12.0267 380.139 10.86 380.419 9.9C380.699 8.92667 381.079 8.14 381.559 7.54C382.039 6.92667 382.599 6.48667 383.239 6.22C383.879 5.94 384.565 5.8 385.299 5.8C386.379 5.8 387.285 6.06 388.019 6.58C388.765 7.08667 389.259 7.86 389.499 8.9H387.619C387.245 7.95333 386.472 7.48 385.299 7.48C384.792 7.48 384.325 7.56667 383.899 7.74C383.472 7.91333 383.099 8.2 382.779 8.6C382.472 9 382.225 9.53333 382.039 10.2C381.852 10.8667 381.745 11.7 381.719 12.7C381.905 12.38 382.132 12.1067 382.399 11.88C382.665 11.64 382.952 11.4533 383.259 11.32C383.579 11.1733 383.905 11.0667 384.239 11C384.572 10.9333 384.892 10.9 385.199 10.9C386.599 10.9 387.712 11.2933 388.539 12.08C389.379 12.8533 389.799 13.9667 389.799 15.42V15.62C389.799 16.2867 389.672 16.9 389.419 17.46C389.179 18.02 388.845 18.5067 388.419 18.92C387.992 19.32 387.492 19.6333 386.919 19.86C386.345 20.0867 385.739 20.2 385.099 20.2ZM384.939 18.52C385.912 18.52 386.652 18.2733 387.159 17.78C387.665 17.2867 387.919 16.5733 387.919 15.64V15.44C387.919 14.52 387.665 13.8133 387.159 13.32C386.652 12.8267 385.912 12.58 384.939 12.58C383.965 12.58 383.225 12.8267 382.719 13.32C382.212 13.8133 381.959 14.52 381.959 15.44V15.64C381.959 16.56 382.212 17.2733 382.719 17.78C383.225 18.2733 383.965 18.52 384.939 18.52Z" fill="var(--rir-alien)"/>
            <rect x="293" y="32" width="96" height="88" fill="var(--rir-arrival)"/>
            <rect x="293" y="32" width="16" height="88" fill="var(--rir-alien)"/>
            <rect x="373" y="32" width="16" height="88" fill="var(--rir-alien)"/>
            <path d="M144.446 18.36H147.786V8.06L144.446 10.44V8.4L147.826 6H149.706V18.36H152.446V20H144.446V18.36ZM153.853 18.46L159.453 13.6C159.879 13.24 160.226 12.9133 160.493 12.62C160.773 12.3267 160.993 12.0533 161.153 11.8C161.313 11.5333 161.419 11.2733 161.473 11.02C161.539 10.7667 161.573 10.4933 161.573 10.2C161.573 9.41333 161.339 8.76667 160.873 8.26C160.406 7.74 159.766 7.48 158.953 7.48C157.979 7.48 157.233 7.74667 156.713 8.28C156.193 8.8 155.933 9.54 155.933 10.5H154.053C154.053 9.82 154.166 9.19333 154.393 8.62C154.633 8.03333 154.966 7.53333 155.393 7.12C155.833 6.70667 156.353 6.38667 156.953 6.16C157.553 5.92 158.219 5.8 158.953 5.8C159.659 5.8 160.293 5.91333 160.853 6.14C161.413 6.35333 161.886 6.66 162.273 7.06C162.659 7.44667 162.953 7.90667 163.153 8.44C163.353 8.97333 163.453 9.56 163.453 10.2C163.453 10.68 163.379 11.1267 163.233 11.54C163.086 11.9533 162.879 12.3467 162.613 12.72C162.359 13.0933 162.046 13.46 161.673 13.82C161.313 14.1667 160.913 14.5267 160.473 14.9L156.293 18.36H163.653V20H153.853V18.46Z" fill="var(--rir-alien)"/>
            <path d="M222.446 18.36H225.786V8.06L222.446 10.44V8.4L225.826 6H227.706V18.36H230.446V20H222.446V18.36ZM231.853 18.46L237.453 13.6C237.879 13.24 238.226 12.9133 238.493 12.62C238.773 12.3267 238.993 12.0533 239.153 11.8C239.313 11.5333 239.419 11.2733 239.473 11.02C239.539 10.7667 239.573 10.4933 239.573 10.2C239.573 9.41333 239.339 8.76667 238.873 8.26C238.406 7.74 237.766 7.48 236.953 7.48C235.979 7.48 235.233 7.74667 234.713 8.28C234.193 8.8 233.933 9.54 233.933 10.5H232.053C232.053 9.82 232.166 9.19333 232.393 8.62C232.633 8.03333 232.966 7.53333 233.393 7.12C233.833 6.70667 234.353 6.38667 234.953 6.16C235.553 5.92 236.219 5.8 236.953 5.8C237.659 5.8 238.293 5.91333 238.853 6.14C239.413 6.35333 239.886 6.66 240.273 7.06C240.659 7.44667 240.953 7.90667 241.153 8.44C241.353 8.97333 241.453 9.56 241.453 10.2C241.453 10.68 241.379 11.1267 241.233 11.54C241.086 11.9533 240.879 12.3467 240.613 12.72C240.359 13.0933 240.046 13.46 239.673 13.82C239.313 14.1667 238.913 14.5267 238.473 14.9L234.293 18.36H241.653V20H231.853V18.46Z" fill="var(--rir-alien)"/>
            <rect x="145" y="32" width="96" height="88" fill="var(--rir-arrival)"/>
            <rect x="145" y="32" width="12" height="88" fill="var(--rir-alien)"/>
            <rect x="229" y="32" width="12" height="88" fill="var(--rir-alien)"/>
            <path d="M6.49648 20.2C5.66982 20.2 4.94315 20.1 4.31648 19.9C3.68982 19.7 3.16315 19.4267 2.73648 19.08C2.32315 18.7333 2.00982 18.3267 1.79648 17.86C1.59648 17.38 1.49648 16.86 1.49648 16.3C1.49648 15.5 1.74982 14.7867 2.25648 14.16C2.76315 13.52 3.50982 13.0667 4.49648 12.8C4.13648 12.68 3.79648 12.52 3.47648 12.32C3.16982 12.1067 2.89648 11.86 2.65648 11.58C2.41648 11.3 2.22982 10.9867 2.09648 10.64C1.96315 10.28 1.89648 9.9 1.89648 9.5C1.89648 8.98 1.99648 8.49333 2.19648 8.04C2.39648 7.58667 2.68982 7.2 3.07648 6.88C3.46315 6.54667 3.94315 6.28667 4.51648 6.1C5.08982 5.9 5.74982 5.8 6.49648 5.8C7.24315 5.8 7.90315 5.9 8.47648 6.1C9.04982 6.28667 9.52982 6.54667 9.91648 6.88C10.3032 7.2 10.5965 7.58667 10.7965 8.04C10.9965 8.49333 11.0965 8.98 11.0965 9.5C11.0965 10.3 10.8432 10.98 10.3365 11.54C9.84315 12.1 9.22982 12.52 8.49648 12.8C9.49648 13.1333 10.2432 13.5733 10.7365 14.12C11.2432 14.6667 11.4965 15.3933 11.4965 16.3C11.4965 16.86 11.3898 17.38 11.1765 17.86C10.9765 18.3267 10.6632 18.7333 10.2365 19.08C9.82315 19.4267 9.30315 19.7 8.67649 19.9C8.04982 20.1 7.32315 20.2 6.49648 20.2ZM6.49648 18.52C7.06982 18.52 7.55648 18.46 7.95648 18.34C8.35648 18.2067 8.67648 18.04 8.91648 17.84C9.16982 17.6267 9.34982 17.38 9.45648 17.1C9.56315 16.8067 9.61648 16.5 9.61648 16.18C9.61648 15.8067 9.53648 15.4667 9.37648 15.16C9.22982 14.8533 9.01648 14.5867 8.73648 14.36C8.45648 14.12 8.12315 13.9333 7.73648 13.8C7.36315 13.6533 6.94982 13.5533 6.49648 13.5C6.04315 13.5533 5.62315 13.6533 5.23648 13.8C4.86315 13.9333 4.53648 14.1133 4.25648 14.34C3.97648 14.5667 3.75648 14.84 3.59648 15.16C3.44982 15.4667 3.37648 15.8067 3.37648 16.18C3.37648 16.5 3.42982 16.8067 3.53648 17.1C3.64315 17.38 3.81648 17.6267 4.05648 17.84C4.30982 18.04 4.63648 18.2067 5.03648 18.34C5.43648 18.46 5.92315 18.52 6.49648 18.52ZM6.49648 12.1C7.29648 11.9933 7.94982 11.74 8.45648 11.34C8.96315 10.9267 9.21648 10.3467 9.21648 9.6C9.21648 8.92 8.98982 8.4 8.53648 8.04C8.09648 7.66667 7.41648 7.48 6.49648 7.48C5.56315 7.48 4.87648 7.66667 4.43648 8.04C3.99648 8.4 3.77648 8.92 3.77648 9.6C3.77648 10.3467 4.02982 10.9267 4.53648 11.34C5.04315 11.74 5.69648 11.9933 6.49648 12.1Z" fill="var(--rir-alien)"/>
            <path d="M88.4965 20.2C87.6698 20.2 86.9432 20.1 86.3165 19.9C85.6898 19.7 85.1632 19.4267 84.7365 19.08C84.3232 18.7333 84.0098 18.3267 83.7965 17.86C83.5965 17.38 83.4965 16.86 83.4965 16.3C83.4965 15.5 83.7498 14.7867 84.2565 14.16C84.7632 13.52 85.5098 13.0667 86.4965 12.8C86.1365 12.68 85.7965 12.52 85.4765 12.32C85.1698 12.1067 84.8965 11.86 84.6565 11.58C84.4165 11.3 84.2298 10.9867 84.0965 10.64C83.9632 10.28 83.8965 9.9 83.8965 9.5C83.8965 8.98 83.9965 8.49333 84.1965 8.04C84.3965 7.58667 84.6898 7.2 85.0765 6.88C85.4632 6.54667 85.9432 6.28667 86.5165 6.1C87.0898 5.9 87.7498 5.8 88.4965 5.8C89.2432 5.8 89.9032 5.9 90.4765 6.1C91.0498 6.28667 91.5298 6.54667 91.9165 6.88C92.3032 7.2 92.5965 7.58667 92.7965 8.04C92.9965 8.49333 93.0965 8.98 93.0965 9.5C93.0965 10.3 92.8432 10.98 92.3365 11.54C91.8432 12.1 91.2298 12.52 90.4965 12.8C91.4965 13.1333 92.2432 13.5733 92.7365 14.12C93.2432 14.6667 93.4965 15.3933 93.4965 16.3C93.4965 16.86 93.3898 17.38 93.1765 17.86C92.9765 18.3267 92.6632 18.7333 92.2365 19.08C91.8232 19.4267 91.3032 19.7 90.6765 19.9C90.0498 20.1 89.3232 20.2 88.4965 20.2ZM88.4965 18.52C89.0698 18.52 89.5565 18.46 89.9565 18.34C90.3565 18.2067 90.6765 18.04 90.9165 17.84C91.1698 17.6267 91.3498 17.38 91.4565 17.1C91.5632 16.8067 91.6165 16.5 91.6165 16.18C91.6165 15.8067 91.5365 15.4667 91.3765 15.16C91.2298 14.8533 91.0165 14.5867 90.7365 14.36C90.4565 14.12 90.1232 13.9333 89.7365 13.8C89.3632 13.6533 88.9498 13.5533 88.4965 13.5C88.0432 13.5533 87.6232 13.6533 87.2365 13.8C86.8632 13.9333 86.5365 14.1133 86.2565 14.34C85.9765 14.5667 85.7565 14.84 85.5965 15.16C85.4498 15.4667 85.3765 15.8067 85.3765 16.18C85.3765 16.5 85.4298 16.8067 85.5365 17.1C85.6432 17.38 85.8165 17.6267 86.0565 17.84C86.3098 18.04 86.6365 18.2067 87.0365 18.34C87.4365 18.46 87.9232 18.52 88.4965 18.52ZM88.4965 12.1C89.2965 11.9933 89.9498 11.74 90.4565 11.34C90.9632 10.9267 91.2165 10.3467 91.2165 9.6C91.2165 8.92 90.9898 8.4 90.5365 8.04C90.0965 7.66667 89.4165 7.48 88.4965 7.48C87.5632 7.48 86.8765 7.66667 86.4365 8.04C85.9965 8.4 85.7765 8.92 85.7765 9.6C85.7765 10.3467 86.0298 10.9267 86.5365 11.34C87.0432 11.74 87.6965 11.9933 88.4965 12.1Z" fill="var(--rir-alien)"/>
            <rect x="1" y="32" width="92" height="88" fill="var(--rir-arrival)"/>
            <rect x="1" y="32" width="8" height="88" fill="var(--rir-alien)"/>
            <rect x="85" y="32" width="8" height="88" fill="var(--rir-alien)"/>
          </svg>

        </r-col>
      </r-row>
      <r-row class="mb-10">
        <r-col
          :cols="{ widest: 8, wide: 8, middle: 3, narrow: 6 }">
        <span class="parmigiano">
          Правило применения и количество колонок для каждого диапазона:
        </span>
        </r-col>
      </r-row>
      <r-row class="mb-10">
        <r-col
          :cols="{ widest: 4, wide: 4, middle: 6, narrow: 6 }">
          <div class="d-flex flex-direction-column">
            <span class="rocky--text burrata mb-1">narrow</span>
            <span class="troy--text parmigiano mb-6">6 колонок</span>
            <svg width="100%" height="88" viewBox="0 0 264 88" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">
              <rect width="44" height="88" fill="var(--rir-arrival)"/>
              <rect width="8" height="88" fill="var(--rir-alien)"/>
              <rect x="36" width="8" height="88" fill="var(--rir-alien)"/>
              <rect x="44" width="44" height="88" fill="var(--rir-arrival)"/>
              <rect x="44" width="8" height="88" fill="var(--rir-alien)"/>
              <rect x="80" width="8" height="88" fill="var(--rir-alien)"/>
              <rect x="88" width="44" height="88" fill="var(--rir-arrival)"/>
              <rect x="88" width="8" height="88" fill="var(--rir-alien)"/>
              <rect x="124" width="8" height="88" fill="var(--rir-alien)"/>
              <rect x="132" width="44" height="88" fill="var(--rir-arrival)"/>
              <rect x="132" width="8" height="88" fill="var(--rir-alien)"/>
              <rect x="168" width="8" height="88" fill="var(--rir-alien)"/>
              <rect x="176" width="44" height="88" fill="var(--rir-arrival)"/>
              <rect x="176" width="8" height="88" fill="var(--rir-alien)"/>
              <rect x="212" width="8" height="88" fill="var(--rir-alien)"/>
              <rect x="220" width="44" height="88" fill="var(--rir-arrival)"/>
              <rect x="220" width="8" height="88" fill="var(--rir-alien)"/>
              <rect x="256" width="8" height="88" fill="var(--rir-alien)"/>
            </svg>

          </div>
        </r-col>
      </r-row>
      <r-row class="mb-10">
        <r-col
          :cols="{ widest: 6, wide: 6, middle: 4, narrow: 6 }">
          <div class="d-flex flex-direction-column">
            <span class="rocky--text burrata mb-1">middle</span>
            <span class="troy--text parmigiano mb-6">6 колонок</span>
            <svg width="100%" height="88" viewBox="0 0 432 88" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">
              <rect width="72" height="88" fill="var(--rir-arrival)"/>
              <rect width="9" height="88" fill="var(--rir-alien)"/>
              <rect x="63" width="9" height="88" fill="var(--rir-alien)"/>
              <rect x="144" width="72" height="88" fill="var(--rir-arrival)"/>
              <rect x="144" width="9" height="88" fill="var(--rir-alien)"/>
              <rect x="207" width="9" height="88" fill="var(--rir-alien)"/>
              <rect x="288" width="72" height="88" fill="var(--rir-arrival)"/>
              <rect x="288" width="9" height="88" fill="var(--rir-alien)"/>
              <rect x="351" width="9" height="88" fill="var(--rir-alien)"/>
              <rect x="72" width="72" height="88" fill="var(--rir-arrival)"/>
              <rect x="72" width="9" height="88" fill="var(--rir-alien)"/>
              <rect x="135" width="9" height="88" fill="var(--rir-alien)"/>
              <rect x="216" width="72" height="88" fill="var(--rir-arrival)"/>
              <rect x="216" width="9" height="88" fill="var(--rir-alien)"/>
              <rect x="279" width="9" height="88" fill="var(--rir-alien)"/>
              <rect x="360" width="72" height="88" fill="var(--rir-arrival)"/>
              <rect x="360" width="9" height="88" fill="var(--rir-alien)"/>
              <rect x="423" width="9" height="88" fill="var(--rir-alien)"/>
            </svg>
          </div>
        </r-col>
      </r-row>
      <r-row>
        <r-col
          :cols="{ widest: 12, wide: 12, middle: 6, narrow: 6 }">
          <div class="d-flex flex-direction-column">
            <span class="rocky--text burrata mb-1">wide, widest</span>
            <span class="troy--text parmigiano mb-6">12 колонок</span>
            <svg width="100%" height="88" viewBox="0 0 863 88" fill="none" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin meet">
              <rect width="72" height="88" fill="var(--rir-arrival)"/>
              <rect width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="60" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="287" width="72" height="88" fill="var(--rir-arrival)"/>
              <rect x="287" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="347" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="575" width="72" height="88" fill="var(--rir-arrival)"/>
              <rect x="575" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="635" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="144" width="72" height="88" fill="var(--rir-arrival)"/>
              <rect x="144" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="204" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="431" width="72" height="88" fill="var(--rir-arrival)"/>
              <rect x="431" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="491" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="719" width="72" height="88" fill="var(--rir-arrival)"/>
              <rect x="719" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="779" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="72" width="72" height="88" fill="var(--rir-arrival)"/>
              <rect x="72" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="132" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="359" width="72" height="88" fill="var(--rir-arrival)"/>
              <rect x="359" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="419" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="647" width="72" height="88" fill="var(--rir-arrival)"/>
              <rect x="647" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="707" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="216" width="72" height="88" fill="var(--rir-arrival)"/>
              <rect x="216" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="276" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="503" width="72" height="88" fill="var(--rir-arrival)"/>
              <rect x="503" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="563" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="791" width="72" height="88" fill="var(--rir-arrival)"/>
              <rect x="791" width="12" height="88" fill="var(--rir-alien)"/>
              <rect x="851" width="12" height="88" fill="var(--rir-alien)"/>
            </svg>

          </div>
        </r-col>
      </r-row>
    </template>
    <template v-if="tabActive.id === 'api'">
      <r-row>
        <r-col :cols="{ widest: 12, wide: 12, middle: 6, narrow: 6 }">

          <div class="taleggio mb-8">Props RRow component</div>
          <r-table
            class="mb-8"
            :headers="headersProps"
            :items="itemsPropsRow"
          >
            <template #nameProp="{ item }">
              <div  v-html="item.nameProp"/>
            </template>
            <template #typeData="{ item }">
              <div  v-html="item.typeData"/>
            </template>
            <template #defaultValue="{ item }">
              <div  v-html="item.defaultValue"/>
            </template>
          </r-table>
          <div class="taleggio mb-8">Props RCol component</div>
          <r-table
            class="mb-8"
            :headers="headersProps"
            :items="itemsPropsCol"
          >
            <template #nameProp="{ item }">
              <div  v-html="item.nameProp"/>
            </template>
            <template #typeData="{ item }">
              <div  v-html="item.typeData"/>
            </template>
            <template #defaultValue="{ item }">
              <div  v-html="item.defaultValue"/>
            </template>
          </r-table>
        </r-col>
      </r-row>
    </template>
    <template v-if="tabActive.id === 'examples'">
      <r-row class="mb-8">
        <r-col
          :cols="{ widest: 12, wide: 12, middle: 6, narrow: 6 }">
          <grid-column-and-offset />
          <grid-adaptive-form />
        </r-col>
      </r-row>
    </template>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import GridColumnAndOffset from '@/components/examples/Grid/GridColumnAndOffset.vue';
import GridAdaptiveForm from '@/components/examples/Grid/GridAdaptiveForm.vue';

@Component({
  components: { GridAdaptiveForm, GridColumnAndOffset },
})
export default class Grid extends Vue {
  headersProps = [
    {
      field: 'nameProp',
      name: 'Название параметра',
      description: 'Наименование входного параметра',
      slot: true,
    },
    {
      field: 'typeData',
      name: 'Тип данных',
      description: 'Применение входного параметра с типом данных',
      slot: true,
    },
    {
      field: 'defaultValue',
      name: 'Значение по умолчанию',
      slot: true,
    },
    {
      field: 'description',
      name: 'Описание',
      description: 'Описание входного параметра',
    },
  ]

  itemsPropsRow = [
    {
      nameProp: '<span class="rocky--text">type</span>',
      typeData: '<span class="matrix--text">string</span>',
      defaultValue: '<span class="alien--text">undefined</span>',
      description: 'Тип сетки применяемой в строке (default или dashboard), если не установлено значение, применяется из [$rir.grids.name]',
    },
    {
      nameProp: '<span class="rocky--text">wrap</span>',
      typeData: '<span class="matrix--text">boolean</span>',
      defaultValue: '<span class="fightclub--text">true</span>',
      description: 'Перенос колонок, если перенос отключен, то строка будет скролится при привышение колонок в сумме',
    },
    {
      nameProp: '<span class="rocky--text">snap</span>',
      typeData: '<span class="matrix--text">boolean</span>',
      defaultValue: '<span class="fightclub--text">false</span>',
      description: 'Автопривязка скрола к точкам внутренего контента',
    },
    {
      nameProp: '<span class="rocky--text">gapHidden</span>',
      typeData: '<span class="matrix--text">boolean</span>',
      defaultValue: '<span class="fightclub--text">false</span>',
      description: 'Убирает боковые отступы сетки',
    },
  ]

  itemsPropsCol = [
    {
      nameProp: '<span class="rocky--text">cols</span>',
      typeData: '<span class="matrix--text">object</span>',
      defaultValue: '<span class="rocky--text">{ widest: 1, wide: 1, middle: 1, narrow: 1 }</span>',
      description: 'Количество колонок занимает данная область',
    },
    {
      nameProp: '<span class="rocky--text">offset</span>',
      typeData: '<span class="matrix--text">object</span>',
      defaultValue: '<span class="rocky--text">{ widest: 0, wide: 0, middle: 0, narrow: 0 }</span>',
      description: 'Количество колонок отступить слева',
    },
    {
      nameProp: '<span class="rocky--text">isWidthContent</span>',
      typeData: '<span class="matrix--text">boolean</span>',
      defaultValue: '<span class="fightclub--text">false</span>',
      description: 'Ширина колонки равна контенту внутри. В расчетах сетки по колонкам не учитывается',
    },
    {
      nameProp: '<span class="rocky--text">isFullWidth</span>',
      typeData: '<span class="matrix--text">boolean</span>',
      defaultValue: '<span class="fightclub--text">false</span>',
      description: 'Растягивает колонку на всю свободную ширину строки. Блокирует параметр isWidthContent',
    },
  ]

  tabActive = {
    id: 'description',
    title: 'Description',
  }

  itemsTabs = [
    {
      id: 'description',
      title: 'Description',
    },
    {
      id: 'api',
      title: 'API',
    },
    {
      id: 'examples',
      title: 'Examples',
    },
  ]
}
</script>

<style scoped lang="scss">
.breakpoint{
  &__block{
    display: flex;
    flex-direction: column;
  }
}
</style>
